var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-title"},[_c('div',{staticClass:"title-tab"},[_c('i',{staticClass:"iconfont",class:_vm.iconf}),_vm._v(" "),_c('h2',{class:{jump: _vm.title === '平台消息'},on:{"click":_vm.jump}},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }